import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'design-system';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { usePrismicDocumentByUID, PrismicRichText } from '@prismicio/react';
import { AppStoreButtons, Page, ResponsiveText } from 'UI';
import './Preview.scss';

const MAX_PAGE_WIDTH = 1080;

export default function PreviewPage() {
  const { slug } = useParams();
  const [document, { state }] = usePrismicDocumentByUID('preview', slug, {});

  if (state === 'loading') return null;

  if (state === 'failed')
    return (
      <Page id="Preview">
        <ResponsiveText type="display" className="title" size="large">
          Naaanni ??
        </ResponsiveText>
        <ResponsiveText className="title">
          Le manga que vous cherchez n'existe pas ou n'est pas disponible.
        </ResponsiveText>
        <Link to="/" className="backhome">
          <Button variant="gold" label="Retour à l'accueil" />
        </Link>
      </Page>
    );
  if (state === 'loaded') {
    const data = document.data;
    return (
      <Page id="Preview">
        <div style={{ maxWidth: MAX_PAGE_WIDTH }} className="header">
          <PrismicRichText field={data.header} />
        </div>

        <div className="pages">
          {data.pages.map((page, index) => (
            <div className="page">
              <img
                alt={`Extrait - page ${index + 1}`}
                src={page.page.url}
                width={MAX_PAGE_WIDTH}
              />
            </div>
          ))}
        </div>
        <div className="page-footer">
          <ResponsiveText>Abonne toi !</ResponsiveText>
          <Link to="/signup">
            <Button
              variant="gold"
              size="large"
              label="Activer mon essai gratuit"
            />
          </Link>
          <div className="download-app">
            <ResponsiveText>Télécharge l'application !</ResponsiveText>
            <AppStoreButtons />
          </div>
        </div>
      </Page>
    );
  }
}
